import React from "react";
import { Icon } from "antd";
import NumberFormat from "../../../../NumberFormat";

/* update_campaign_dates — cambio de fechas (con impacto de presupuesto en tradicionales). */
export default function DatesProposal({ payload, t }) {
  return (
    <div className="chatbot-proposal-body">
      <p className="chatbot-proposal-reason">{t("ChatbotProposalDates")}</p>
      <div className="chatbot-proposal-change-row">
        <span>{payload.current_date_from} → {payload.current_date_to}</span>
        <Icon type="arrow-right" />
        <span className="chatbot-proposal-new-value">
          {payload.new_date_from} → {payload.new_date_to}
        </span>
      </div>
      {payload.new_budget != null && (
        <div className="chatbot-proposal-change-row">
          <span>
            {payload.current_budget != null ? (
              <NumberFormat
                value={payload.current_budget}
                currency={payload.currency}
              />
            ) : ""}
          </span>
          <Icon type="arrow-right" />
          <span className="chatbot-proposal-new-value">
            <NumberFormat
              value={payload.new_budget}
              currency={payload.currency}
            />
          </span>
        </div>
      )}
    </div>
  );
}
